var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as _ from "lodash";
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
var BestPracticeController = /** @class */ (function () {
    function BestPracticeController() {
    }
    /*****************************************************************************************************
        * Is using route "api/post/BestPracticePost" and http method "POST" to call the back-end.
    
        * @param {File} media
        * @param {{[key: string]: File}} medias
        * @param {BestPracticePostUploadDto} data
        * @param {{[key: string]: File}} content
        * @returns {BestPracticePostDownloadDto}
    ******************************************************************************************************/
    BestPracticeController.PostBestPractice = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        _.forEach(data.medias, function (val, key) { return fd.append(key, val); });
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.content, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/BestPracticePost", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/BestPracticePost/{id}" and http method "PATCH" to call the back-end.
    
        * @param {string} id
        * @param {File} media
        * @param {{[key: string]: File}} medias
        * @param {BestPracticePostUploadDto} data
        * @param {{[key: string]: File}} content
        * @returns {BestPracticePostDownloadDto}
    ******************************************************************************************************/
    BestPracticeController.PatchBestPractice = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        if (data.media)
            fd.append("media", data.media);
        _.forEach(data.medias, function (val, key) { return fd.append(key, val); });
        fd.append("data", JSON.stringify(data.data));
        _.forEach(data.content, function (val, key) { return fd.append(key, val); });
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/BestPracticePost/{id}", __assign({}, data)),
            method: "PATCH",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/BestPracticePost/{id}/implementation" and http method "POST" to call the back-end.
    
        * @param {string} id
        * @param {{[key: string]: File}} medias
        * @param {ImplementationUploadDto} data
        * @returns {void}
    ******************************************************************************************************/
    BestPracticeController.PostBestPracticeImplementation = function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        _.forEach(data.medias, function (val, key) { return fd.append(key, val); });
        fd.append("data", JSON.stringify(data.data));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/BestPracticePost/{id}/implementation", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    };
    /*****************************************************************************************************
        * Is using route "api/post/BestPracticePost/{id}/implementation" and http method "GET" to call the back-end.
    
        * @param {string} id
        * @returns {ImplementationDownloadDto[]}
    ******************************************************************************************************/
    BestPracticeController.GetBestPracticeImplementation = function (data, onSuccess, onError, onProgress, mutex) {
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/post/BestPracticePost/{id}/implementation", __assign({}, data)),
            method: "GET",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
        });
    };
    return BestPracticeController;
}());
export { BestPracticeController };
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=BestPracticeController.js.map